import { render, staticRenderFns } from "./SignDraft.vue?vue&type=template&id=7bd1fe20&scoped=true&"
import script from "./SignDraft.vue?vue&type=script&lang=js&"
export * from "./SignDraft.vue?vue&type=script&lang=js&"
import style0 from "./SignDraft.vue?vue&type=style&index=0&id=7bd1fe20&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1fe20",
  null
  
)

export default component.exports